export default __webpack_public_path__ + "static/app-breach-alert-20093882fe2516e4eb1779af2a9e5133.svg";